<div class="deviations ms-3">
  <div class="clearfix">
    <h5 class="float-start">{{'quantity.deviations'|translate}}</h5>
    <div class="float-end deviation-legend">
      <div class="me-2">
        <div class="severity bg-warning">&nbsp;</div>
        <div>{{'ui.warning'|translate}}</div>
      </div>
      <div>
        <div class="severity bg-danger">&nbsp;</div>
        <div>{{'ui.blocking'|translate}}</div>
      </div>
    </div>
  </div>
  <div class="list">
    <deviation *ngFor="let deviation of deviations"
      [subject]="deviation.subjectType"
      [subjectId]="deviation.subjectID"
      [severity]="deviation.severity"
      [description]="deviation.description"
      [count]="deviation.count">
    </deviation>
  </div>
  <div class="actions clearfix mt-2">
    <button type="button" class="btn btn-sm btn-outline-secondary float-end" (click)="showDeviations()">
      {{'quantity.deviations'|translate}} {{'ui.and'|translate|lowercase}} {{'ui.details'|translate|lowercase}} {{'ui.show-verb'|translate|lowercase}}
    </button>
  </div>
</div>
